module.exports = __webpack_public_path__ + "static/media/face-euphoria.ec9d8af9.webp";